<a (click)="redirect()" class="btn back-button" id="back-btn">
  <img src="assets/icons/arrow-left-green.svg" alt="blanc back btn">
  <span>Back</span>
</a>
